import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CreateUser, CurrentSessionId, Disconnect, Email, Login, OtpRequest, RefreshToken, RefreshTokenRequest, ResetPassword, SignUp, Tokens, User } from 'src/app/features/login/login';
import { LoginResponse } from 'src/app/model/response/auth-r';
import { environment } from 'src/environments/environment';
import { Session } from 'src/app/features/login/login';
import { UserDataStringResponse } from 'src/app/model/response/user/user';
import { CryptHelperService } from 'src/app/services/helpers/crypt-helper.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private url: string = environment.apiUrl + "/users";

  loginSubject: Subject<boolean> = new Subject<boolean>();
  alreadyLoggedIn: Subject<boolean> = new Subject<boolean>();


  constructor(private http: HttpClient, private crypter: CryptHelperService) { }

  /**
   * login
   * @param login email and password
   * @returns Access Toklen and Refresh Token
   */
  login(login: Login): Observable<Tokens> {
    return this.http.post<Tokens>(`${this.url}/login/admin`, login);
  }

  /**
   * Aggiorna token
   * @param data the refresh token
   * @returns updated token
   */
  refreshToken(data: RefreshTokenRequest): Observable<Tokens> {
    return this.http.patch<Tokens>(`${this.url}/refresh-token`, data);
  }

  /**
   * gets session uuid from current token
   * @param token 
   * @returns session id
   */
  getCurrentSession(token: string): Observable<CurrentSessionId> {
    let request: RefreshTokenRequest = { refreshToken: token };
    return this.http.post<CurrentSessionId>(`${this.url}/current-session`, request);
  }

  /**
  * gets current user data
  * @returns user data 
  */
  getCurrentUserProfile(): Observable<User> {
    return this.http.get<User>(`${this.url}/me`);
  }

  /**
   * Add new user with user role
   * @param register data to register
   */
  signUpUser(register: CreateUser): Observable<User> {
    return this.http.post<User>(`${this.url}/register`, register);
  }

  /**
   * disconnects current session but keeps others alive
   * @param token refresh token to invalidate
   */
  disconnectCurrentSession(token: string): Observable<void> {

    let disconnect: Disconnect = {
      refreshToken: token
    }

    //force body into delete 
    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: disconnect,
    }

    return this.http.delete<void>(`${this.url}/disconnect`, options);
  }


  /**
   * disconnects single session based on the session uuid
   * @param disconnect refresh token to invalidate
   */
  disconnectSingleSession(token: string): Observable<void> {

    let disconnect: Disconnect = {
      refreshToken: token
    }

    //force body into delete 
    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: disconnect,
    }

    return this.http.delete<void>(`${this.url}/disconnect`, options);
  }

  /**
   * disconnects all sessions of user
   * @param disconnect refresh token to invalidate
   */
  disconnectAllSessions(token: string): Observable<void> {

    let disconnect: Disconnect = {
      refreshToken: token
    }

    //force body into delete 
    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: disconnect,
    }

    return this.http.delete<void>(`${this.url}/disconnect-all`, options);
  }






  /**
   *
   * Controls if an username already exists to prevent duplicate accounts
   */
  usernameExists(username: string): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiUrl}/user/exist/username/${username}`);
  }

  /**
   *
   * Controls if an email already exists to prevent duplicate accounts
   */
  emailExists(email: string): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiUrl}/user/exist/mail/${email}`);
  }

  sendOtp(email: Email): Observable<any> {
    console.log(email)
    return this.http.post<any>(`${this.url}/mail/otp`, email);
  }

  checkOtp(request: OtpRequest): Observable<any> {
    return this.http.put<any>(`${this.url}/check/otp`, request)
  }

  delOtp(request: Email): Observable<any> {
    return this.http.post<any>(`${this.url}/delete/otp`, request)
  }

  resetPwd(request: ResetPassword): Observable<any> {
    return this.http.put<any>(`${this.url}/resetp`, request)
  }

  /**
   * Get all the user data by id and filiale and roles as string[]
   */
  getUserDatastring(id: number): Observable<UserDataStringResponse> {
    return this.http.get<UserDataStringResponse>(`${environment.apiUrl}/user/data/string/${id}`);
  }


}

